import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"
import moment from "moment"
import { formatDateToString } from "helpers/dates"

const QUICK_ANSWERS_DATE_FORMAT = "MMM DD, YYYY"

export default function ContextInfo({ resource, benchmark, model, startDate, endDate, earliestDate, latestDate, label = "Current Context:" }) {
  const formattedStartDate = formatDateToString(moment(startDate), QUICK_ANSWERS_DATE_FORMAT)
  const formattedEndDate = formatDateToString(moment(endDate), QUICK_ANSWERS_DATE_FORMAT)
  const formattedEarliestDate = formatDateToString(moment(earliestDate), QUICK_ANSWERS_DATE_FORMAT)
  const formattedLatestDate = formatDateToString(moment(latestDate), QUICK_ANSWERS_DATE_FORMAT)

  return (
    <Box className="context-info">
      <Typography variant="body2" color="text.secondary" className="context-label" gutterBottom>
        <b>{label}</b>
      </Typography>
      <ul className="context-list">
        <li>
          <b>Resource</b>: {resource?.name || "Unknown Resource"}
        </li>
        {benchmark && <li>
          <b>Benchmark</b>: {benchmark.name}
        </li>}
        {model && <li>
          <b>Model</b>: {model.name}
        </li>}
        {earliestDate && latestDate && <li>
          <b>Availability</b>: {formattedEarliestDate} - {formattedLatestDate}
        </li>}
        {startDate && endDate && <li>
          <b>Period</b>: {formattedStartDate} - {formattedEndDate}
        </li>}
      </ul>
    </Box>
  )
}

ContextInfo.propTypes = {
  resource: PropTypes.object.isRequired,
  benchmark: PropTypes.object,
  model: PropTypes.object,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  earliestDate: PropTypes.object,
  latestDate: PropTypes.object,
  label: PropTypes.string,
}
